import React from "react";
import { Redirect, Route } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import {Content} from "./Content";
import { isRoutePermissionAllowed } from "../../../../app/permissions/routePermissions";

export function ContentRoute({ children, component, render, allowedRoles, ...props }) {
  const user = useSelector(({ auth }) => auth.user, shallowEqual);
  const roleAllowed = isRoutePermissionAllowed(allowedRoles, user);

  return (
    <Route {...props}>
      {routeProps => {
        if (!routeProps.match) {
          return null;
        }

        if (!roleAllowed) {
          return <Redirect to="/dashboard" />;
        }

        if (typeof children === "function") {
          return <Content>{children(routeProps)}</Content>;
        }

        if (children) {
          return <Content>{children}</Content>;
        }

        if (component) {
          return (
            <Content>{React.createElement(component, routeProps)}</Content>
          );
        }

        if (render) {
          return <Content>{render(routeProps)}</Content>;
        }

        return null;
      }}
    </Route>
  );
}
